import React, { useEffect, useRef, useState } from 'react'
import styles from './ImmediateOwnerShip.module.css'
import AnimatedButton from '../AnimatedButton/AnimatedButton'
import NewModal from '../NewModal/NewModal'
import { useNavigate } from "react-router-dom";
import { useAgentStore } from '../../Store/agentDetailStore';
import {
    fetchAgentDetailById,
    fetchAvailablePhoneNumberByCountry,
    fetchAvailableVobizNumbers,
} from '../../Store/apiStore';
import decodeToken from "../../lib/decodeToken";
import Loader2 from '../Loader2/Loader2';
import GoogleAddressInputWithDropdown from '../GoogleAddressInputWithDropdown/GoogleAddressInputWithDropdown';
import {
    isPythonBackend,
    usesVobiz,
    isSupportedNumberCountry,
    unsupportedNumberCountryMessage,
} from '../../utils/apiBackend';


const ImmediateOwnerShip = ({

    wizardMode = false,
    onWizardNext,
    onWizardBack,
    onWizardClose,
    wizardCity = "",
    wizardAgentName = "",


    wizardCandidateNumber = "",
    wizardCanEdit = false,
    wizardConfirming = false,
    wizardConfirmError = "",
    onWizardConfirmPurchase,
    onWizardEditNumber,

    wizardInlinePicker = false,
    wizardBusinessCountry = "",
    wizardBusinessCity = "",
    wizardBusinessState = "",

    onWizardSkipPhoneSetup,
} = {}) => {
    const {
        agentData,
        assignedNumbers,
        totalBookings,
        setAgentById,
        setCurrentAgentId,
        getAgentById,
    } = useAgentStore();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();


    const [showPopup, setShowPopup] = useState(false);
    const [popupType, setPopupType] = useState("");
    const [popupMessage, setPopupMessage] = useState("");
    const [selectedNumber, setSelectedNumber] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const [copiedFlash, setCopiedFlash] = useState(false);
    const [agentDetails, setAgentDetails] = useState(null);
    const [businessDetails, setBusinessDetails] = useState(null);

    const [showSkipConfirm, setShowSkipConfirm] = useState(false);

    // Receptionist ka naam — label "Sasha's Number" jaisa dikhane ke liye.
    // Wizard prop pehle, warna fetched/store wala agent name.
    const agentDisplayName = (
        wizardAgentName ||
        agentDetails?.agentName ||
        agentData?.agent?.agentName ||
        ""
    ).trim();

    const agentId = sessionStorage.getItem("SelectAgentId");
    const agentBuisnesId = sessionStorage.getItem("SelectAgentBusinessId");
    const token = localStorage.getItem("token") || "";
    const { id: userId } = decodeToken(token) || {};
    const [dashboardLoading, setDashboardLoading] = useState(false);
    const [pickerOpen, setPickerOpen] = useState(false);
    const [pickerNumbers, setPickerNumbers] = useState([]);
    const [pickerSelectedNumber, setPickerSelectedNumber] = useState("");
    const [pickerCity, setPickerCity] = useState("");
    const [pickerState, setPickerState] = useState("");
    const [pickerCountry, setPickerCountry] = useState("");
    const [pickerLoading, setPickerLoading] = useState(false);
    const [pickerError, setPickerError] = useState("");

    const [pickerLocationAddress, setPickerLocationAddress] = useState("");
    const pickerDebounceRef = useRef(null);
    const pickerGoogleInputRef = useRef(null);
    const pickerHasSetInitialAddressRef = useRef(false);


    const fetchPickerNumbers = async (countryCode, cityName, stateCode) => {
        if (!countryCode) return;

        const upper = (countryCode || "").toUpperCase();
        if (!isSupportedNumberCountry(upper)) {
            setPickerNumbers([]);
            setPickerSelectedNumber("");
            setPickerError(unsupportedNumberCountryMessage());
            return;
        }
        setPickerLoading(true);
        setPickerError("");
        try {
            const isVobiz = usesVobiz() || upper === "IN";
            const res = isVobiz
                ? await fetchAvailableVobizNumbers(
                    token,
                    "IN",
                    cityName || "Bangalore",
                    stateCode || "KA",
                    null,
                    null,
                )
                : await fetchAvailablePhoneNumberByCountry(
                    token,
                    countryCode,
                    cityName || "",
                    stateCode || "",
                    null,
                    null,
                );
            const list = res?.data || [];
            setPickerNumbers(list);

            const candidateInList = list.find(
                (n) => n.phone_number === wizardCandidateNumber,
            );
            if (candidateInList) {
                setPickerSelectedNumber(candidateInList.phone_number);
            } else if (list.length > 0) {
                setPickerSelectedNumber(list[0].phone_number);
            } else {
                setPickerSelectedNumber("");
            }
        } catch (err) {
            console.error(
                "[ImmediateOwnerShip] picker fetch failed:",
                err?.response?.data || err?.message || err,
            );
            setPickerError(
                "Couldn't load alternative numbers. Please try again.",
            );
            setPickerNumbers([]);
        } finally {
            setPickerLoading(false);
        }
    };


    const parsePickerAddressAndFetch = (address) => {
        if (!address || address.length < 3) return;
        if (typeof window === "undefined" || !window.google?.maps?.Geocoder) {
            setPickerError(
                "Address lookup unavailable. Please try again in a moment.",
            );
            return;
        }
        setPickerLoading(true);
        setPickerError("");
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, status) => {
            if (status === "OK" && results && results[0]) {
                let cityName = "";
                let stateCode = "";
                let countryCode = "";
                results[0].address_components.forEach((component) => {
                    if (component.types.includes("locality")) {
                        cityName = component.long_name;
                    }
                    if (component.types.includes("administrative_area_level_1")) {
                        stateCode = component.short_name;
                    }
                    if (component.types.includes("country")) {
                        countryCode = component.short_name;
                    }
                });
                if (countryCode) {

                    const upper = (countryCode || "").toUpperCase();
                    if (!isSupportedNumberCountry(upper)) {
                        setPickerLoading(false);
                        setPickerCountry(upper);
                        setPickerCity(cityName);
                        setPickerState(stateCode);
                        setPickerError(unsupportedNumberCountryMessage());
                        return;
                    }
                    setPickerCountry(upper);
                    setPickerCity(cityName);
                    setPickerState(stateCode);
                    fetchPickerNumbers(upper, cityName, stateCode);
                } else {
                    setPickerLoading(false);
                    setPickerError(
                        "Couldn't determine country from that address. Please try a more specific location.",
                    );
                }
            } else {
                setPickerLoading(false);
                if (status !== "ZERO_RESULTS") {
                    setPickerError(
                        "Couldn't look up that address. Please try again.",
                    );
                } else {
                    setPickerError(
                        "No matching location found. Try a city + state.",
                    );
                }
            }
        });
    };


    useEffect(() => {
        if (!pickerOpen) return;
        if (!pickerLocationAddress || pickerLocationAddress.length < 3) return;
        if (pickerHasSetInitialAddressRef.current) {

            pickerHasSetInitialAddressRef.current = false;
            return;
        }
        if (pickerDebounceRef.current) {
            clearTimeout(pickerDebounceRef.current);
        }
        pickerDebounceRef.current = setTimeout(() => {
            parsePickerAddressAndFetch(pickerLocationAddress);
        }, 1500);
        return () => {
            if (pickerDebounceRef.current) {
                clearTimeout(pickerDebounceRef.current);
            }
        };

    }, [pickerLocationAddress, pickerOpen]);


    const handleOpenPicker = () => {
        if (pickerOpen) {

            setPickerOpen(false);
            return;
        }

        const country = (
            wizardBusinessCountry ||
            businessDetails?.country_code ||
            ""
        )
            .toString()
            .toUpperCase();
        const city = wizardBusinessCity || businessDetails?.city || "";
        const stateCode =
            wizardBusinessState ||
            businessDetails?.state_code ||
            businessDetails?.state ||
            "";
        if (!country) {
            setPickerError(
                "Couldn't determine your business country. Please try again.",
            );
            setPickerOpen(true);
            return;
        }
        setPickerCountry(country);
        setPickerCity(city);
        setPickerState(stateCode);

        const seedAddress = [city, stateCode].filter(Boolean).join(", ") || country;
        pickerHasSetInitialAddressRef.current = true;
        setPickerLocationAddress(seedAddress);
        setPickerOpen(true);

        if (pickerNumbers.length === 0) {
            fetchPickerNumbers(country, city, stateCode);
        }
    };




    useEffect(() => {
        if (!agentId) {
            console.error("No agentId found in session storage");
            setIsLoading(false);
            return;
        }



        const fetchAndSetBusinessDetails = async () => {
            try {
                setIsLoading(true);
                let fetchedAgentDetails = null;
                let fetchedBusinessDetails = null;

                // First try to get from store
                const res = getAgentById(agentId);




                if (!agentBuisnesId) {
                    console.error("No business ID found");
                    setPopupType("error");
                    setPopupMessage("Missing business information. Please try again.");
                    setShowPopup(true);
                    setIsLoading(false);
                    return;
                }

                const agentRequestDetails = {
                    agentId: agentId,
                    bussinesId: agentBuisnesId
                };

                const response = await fetchAgentDetailById(agentRequestDetails);
                // console.log("API response:", response);

                const agentInfo = response?.data;

                if (agentInfo && agentInfo.agent) {
                    fetchedAgentDetails = agentInfo.agent;
                    fetchedBusinessDetails = agentInfo.business;

                    setAgentDetails(fetchedAgentDetails);
                    setBusinessDetails(fetchedBusinessDetails);

                    // Save to store
                    let numbersArray = [];
                    let total = 0;
                    setAgentById(agentId, agentInfo, numbersArray, total);

                    const rawVoip = fetchedAgentDetails.voip_numbers;
                    let voipNumbers = null;
                    if (Array.isArray(rawVoip)) {
                        voipNumbers = rawVoip;
                    } else if (typeof rawVoip === "string" && rawVoip.length > 0) {
                        try {
                            const parsed = JSON.parse(rawVoip);
                            voipNumbers = Array.isArray(parsed) ? parsed : [parsed];
                        } catch (error) {

                            voipNumbers = [rawVoip];
                        }
                    }

                    if (Array.isArray(voipNumbers) && voipNumbers.length > 0 && voipNumbers[0]) {
                        setSelectedNumber(voipNumbers[0]);

                    } else {
                        console.warn(
                            "No usable voip_numbers in agent data — raw value:",
                            rawVoip
                        );
                    }
                } else {
                    console.error("Invalid API response structure");
                    setPopupType("error");
                    setPopupMessage("Invalid data received. Please try again.");
                    setShowPopup(true);
                }
                // }

                setIsLoading(false);


            } catch (err) {
                console.error("Failed to fetch data:", err);
                setPopupType("error");
                setPopupMessage(
                    err?.response?.data?.message ||
                    "Failed to load business details. Please try again."
                );
                setShowPopup(true);
                setIsLoading(false);
            }
        };

        fetchAndSetBusinessDetails();
    }, [agentId, agentBuisnesId, getAgentById, setAgentById]);

    // Copy number to clipboard
    const handleCopyNumber = async () => {
        if (!selectedNumber) {
            setPopupType("warning");
            setPopupMessage("No number to copy");
            setShowPopup(true);
            return;
        }
        try {
            await navigator.clipboard.writeText(selectedNumber);
            setCopiedFlash(true);
            setTimeout(() => setCopiedFlash(false), 1800);
            if (!wizardMode) {
                setPopupType("success");
                setPopupMessage("Number copied to clipboard!");
                setShowPopup(true);
                setTimeout(() => {
                    setShowPopup(false);
                }, 2000);
            }
        } catch (error) {
            console.error("Failed to copy:", error);
            setPopupType("error");
            setPopupMessage("Failed to copy number");
            setShowPopup(true);
        }
    };


    const handleSetupCallForwarding = async () => {

        if (
            wizardMode &&
            wizardInlinePicker &&
            pickerOpen &&
            pickerSelectedNumber &&
            typeof onWizardConfirmPurchase === "function"
        ) {
            if (wizardConfirming) return;
            const pickedObj = pickerNumbers.find(
                (n) => n.phone_number === pickerSelectedNumber,
            );
            const regions = pickedObj?.region_information || [];
            const cityRegion = regions.find(
                (r) =>
                    r.region_type === "rate_center" ||
                    r.region_type === "rate-center" ||
                    r.region_type === "city" ||
                    r.region_type === "locality",
            );
            const stateRegion = regions.find(
                (r) =>
                    r.region_type === "state" ||
                    r.region_type === "administrative_area",
            );
            const titleCase = (s) =>
                String(s || "")
                    .toLowerCase()
                    .replace(/\b\w/g, (c) => c.toUpperCase());
            const overrideCandidate = {
                phone_number: pickerSelectedNumber,
                locality:
                    titleCase(cityRegion?.region_name) ||
                    pickerCity ||
                    "",
                region: (
                    stateRegion?.region_name ||
                    pickerState ||
                    ""
                ).toUpperCase(),
            };
            try {
                const result = await onWizardConfirmPurchase(overrideCandidate);
                if (result?.success && typeof onWizardNext === "function") {
                    onWizardNext(pickerSelectedNumber);
                }
            } catch (err) {
                console.error("[ImmediateOwnerShip] Use-This-Number flow threw:", err);
            }
            return;
        }


        if (
            wizardMode &&
            wizardCandidateNumber &&
            !selectedNumber &&
            typeof onWizardConfirmPurchase === "function"
        ) {
            if (wizardConfirming) return; // double-tap guard
            try {
                const result = await onWizardConfirmPurchase();
                if (result?.success && typeof onWizardNext === "function") {
                    onWizardNext(wizardCandidateNumber);
                }

            } catch (err) {
                console.error("[ImmediateOwnerShip] Confirm flow threw:", err);
            }
            return;
        }


        if (!selectedNumber) {
            setPopupType("warning");
            setPopupMessage("Please wait while we load your phone number");
            setShowPopup(true);
            return;
        }
        if (wizardMode && typeof onWizardNext === "function") {
            onWizardNext(selectedNumber);
            return;
        }
        navigate("/select-carrier");
    };

    const handleGoToDashboard = async () => {
        if (dashboardLoading) return;

        setDashboardLoading(true);
        setDashboardLoading(false);
        if (wizardMode && typeof onWizardClose === "function") {
            onWizardClose();
            return;
        }
        navigate("/fast-agent-detail", { replace: true });


    };



    const headerPreviewFromPicker =
        wizardInlinePicker && pickerOpen && pickerSelectedNumber;
    const headerDisplayNumber =
        headerPreviewFromPicker ||
        wizardCandidateNumber ||
        selectedNumber ||
        "";
    const hasDisplayNumber = !!headerDisplayNumber;
    const isCountryGateError =
        typeof pickerError === "string" &&
        (pickerError.startsWith("Only US/Canada") || pickerError.startsWith("Only India"));
    const formatPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return "";

        // Already formatted number
        if (/^\+\d{1,3}\s\d{3}-\d{3}-\d{4}$/.test(phoneNumber)) {
            return phoneNumber;
        }

        // Keep only digits and +
        const value = String(phoneNumber).trim();
        const digits = value.replace(/\D/g, "");

        // US/Canada: 12253459542 -> +1 225-345-9542
        if (digits.length === 11 && digits.startsWith("1")) {
            return `+1 ${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7, 11)}`;
        }

        // 10 digit US number: 2253459542 -> +1 225-345-9542
        if (digits.length === 10) {
            return `+1 ${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
        }

        // Fallback for other formats
        return phoneNumber;
    };
    return (
        <>
            {dashboardLoading && (
                <div className={styles.loadingOverlay}>
                    <Loader2 />
                </div>
            )}

            <div
                className={`${styles.containerBox}${wizardMode ? ` ${styles.containerBoxWizard}` : ""}`}
            >
                <div className={styles.container}>
                    {wizardInlinePicker ? (

                        <div className={`${styles.titleBar} ${styles.titleBarPicker}`}>
                            <h4 className={`${styles.lightTitle} ${styles.pickerTitleLight}`}>
                                Your Receptionist's
                            </h4>
                            <h5 className={`${styles.boldTitle} ${styles.pickerTitleBold}`}>
                               Business Number
                            </h5>

                            <p className={styles.pickerSubtitle}>
                                {hasDisplayNumber ? (
                                    <>
                                        We have assigned a premium, local{" "}
                                        <b className={styles.highlight}>
                                            {wizardCity || (usesVobiz() ? "Bangalore" : "US")}
                                        </b>{" "}
                                        number to <b className={styles.highlight}>
                                            {wizardAgentName || "your agent"},
                                        </b> your AI Receptionist.
                                    </>
                                ) : isCountryGateError ? (
                                    <>
                                        Phone numbers aren't available in your
                                        country yet. You can pick a US or Canada
                                        location below, or skip phone setup.
                                    </>
                                ) : (
                                    <>
                                        We couldn't find a local number for{" "}
                                        <b className={styles.highlight}>
                                            {wizardAgentName || "your agent"}
                                        </b>{" "}
                                        yet.
                                        {!usesVobiz() && (
                                            <>
                                                {" "}Use{" "}
                                                <b className={styles.highlight}>
                                                    Find More Options
                                                </b>{" "}
                                                below to search a different city.
                                            </>
                                        )}
                                    </>
                                )}
                            </p>
                        </div>
                    ) : wizardMode ? (

                        <div className={`${styles.titleBar} ${styles.titleBarWizard}`}>
                            <h5 className={`${styles.boldTitle} ${styles.wizardTitle}`}>
                                Your receptionist comes with its own local business number
                            </h5>

                            <p className={styles.wizardSubtitle}>
                                {hasDisplayNumber ? (
                                    <>
                                        We have assigned a premium, local{" "}
                                        <b className={styles.highlight}>
                                            {wizardCity || (usesVobiz() ? "Bangalore" : "US")}
                                        </b>{" "}
                                        Number to your Receptionist,{" "}
                                        <b className={styles.highlight}>
                                            {wizardAgentName || "your agent"}
                                        </b>
                                        .
                                    </>
                                ) : isCountryGateError ? (
                                    <>
                                        Phone numbers aren't available in your
                                        country yet. Pick a US or Canada
                                        location, or skip phone setup.
                                    </>
                                ) : (
                                    <>
                                        We couldn't find a local number for{" "}
                                        <b className={styles.highlight}>
                                            {wizardAgentName || "your agent"}
                                        </b>{" "}
                                        yet. We'll keep looking — or you can
                                        edit the location to search elsewhere.
                                    </>
                                )}
                            </p>
                        </div>
                    ) : (
                        <div className={styles.titleBar}>
                            <h4 className={styles.lightTitle}>Your Agent phone</h4>
                            <h5 className={styles.boldTitle}>number is ready</h5>
                        </div>
                    )}


                    {(() => {

                        const previewFromPicker =
                            wizardInlinePicker &&
                            pickerOpen &&
                            pickerSelectedNumber;
                        const displayNumber =
                            previewFromPicker ||
                            wizardCandidateNumber ||
                            selectedNumber;
                        const isCandidatePreview =
                            !!wizardCandidateNumber && !selectedNumber;
                        return (
                            <div
                                className={`${styles.phoneCard}${wizardInlinePicker ? ` ${styles.phoneCardPicker}` : ""}`}
                            >
                                {wizardInlinePicker && displayNumber && (
                                    <div className={styles.currentNumberWrap}>
                                        <span className={styles.currentNumberLabel}>
                                            {agentDisplayName
                                                ? `${agentDisplayName}'s Number`
                                                : "Your Current Number"}
                                        </span>
                                        <span className={styles.number}>
                                            {formatPhoneNumber(displayNumber)}
                                        </span>
                                    </div>
                                )}
                                {!wizardInlinePicker && isLoading && !displayNumber ? (
                                    <span className={styles.number}>Loading...</span>
                                ) : !wizardInlinePicker && displayNumber ? (
                                    <span className={styles.number}>{displayNumber}</span>
                                ) : !wizardInlinePicker ? (
                                    <span className={`${styles.number} ${styles.numberUnavailable}`}>
                                        No number available
                                    </span>
                                ) : null}
                                {wizardInlinePicker && !displayNumber && (
                                    <span className={`${styles.number} ${styles.numberUnavailablePicker}`}>
                                        {isLoading ? "Loading..." : "No number available"}
                                    </span>
                                )}

                                <div className={styles.copyWrap}>
                                    {copiedFlash && (
                                        <span className={styles.copyTooltip}>
                                            Copied
                                        </span>
                                    )}
                                    <button
                                        className={styles.copyBtn}
                                        onClick={() => {

                                            if (!displayNumber) {
                                                setPopupType("warning");
                                                setPopupMessage("No number to copy");
                                                setShowPopup(true);
                                                return;
                                            }
                                            navigator.clipboard
                                                .writeText(displayNumber)
                                                .then(() => {
                                                    setCopiedFlash(true);
                                                    setTimeout(() => setCopiedFlash(false), 1800);
                                                    if (!wizardMode) {
                                                        setPopupType("success");
                                                        setPopupMessage("Number copied to clipboard!");
                                                        setShowPopup(true);
                                                        setTimeout(() => setShowPopup(false), 2000);
                                                    }
                                                })
                                                .catch(() => {
                                                    setPopupType("error");
                                                    setPopupMessage("Failed to copy number");
                                                    setShowPopup(true);
                                                });
                                        }}
                                        disabled={!displayNumber || isLoading || wizardConfirming}
                                        title="Copy number"
                                    >
                                        <img src="/svg/copy-icon2.svg" alt="copy" />
                                    </button>
                                </div>


                                {wizardMode &&
                                    !wizardInlinePicker &&
                                    wizardCanEdit &&
                                    isCandidatePreview &&
                                    typeof onWizardEditNumber === "function" && (
                                        <div className={styles.copyWrap}>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (wizardConfirming) return;
                                                    onWizardEditNumber();
                                                }}
                                                disabled={wizardConfirming}
                                                title="Pick a different number"
                                                aria-label="Edit — pick a different number"
                                                className={styles.editBtn}
                                            >

                                                <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M4 20h4l10-10-4-4L4 16v4z"
                                                        stroke="currentColor"
                                                        strokeWidth="1.8"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M14 6l4 4"
                                                        stroke="currentColor"
                                                        strokeWidth="1.8"
                                                        strokeLinecap="round"
                                                    />
                                                </svg>
                                            </button>
                                            <span className={styles.editLabel}>
                                                Edit
                                            </span>
                                        </div>
                                    )}
                            </div>
                        );
                    })()}


                    {wizardInlinePicker && wizardCanEdit && !usesVobiz() && (
                        <button
                            type="button"
                            onClick={handleOpenPicker}
                            disabled={wizardConfirming}
                            className={styles.findMoreBtn}
                            aria-expanded={pickerOpen}
                            aria-controls="goLive-inline-picker"
                        >
                            {/* "Close" state me edit icon nahi dikhana */}
                            {!pickerOpen && (
                                <span className={styles.findMoreIcon} aria-hidden="true">
                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="0.5" y="0.5" width="29" height="29" rx="9.5" fill="white" stroke="#E8E9EE" />
                                        <path d="M14.1172 21.125H21.0145" stroke="#24252C" stroke-linecap="round" />
                                        <path d="M17.564 8.47616C17.8689 8.17128 18.2824 8 18.7136 8C19.1448 8 19.5583 8.17128 19.8632 8.47616C20.168 8.78105 20.3393 9.19455 20.3393 9.62572C20.3393 10.0569 20.168 10.4704 19.8632 10.7753L11.0499 19.5886L7.98438 20.3549L8.75075 17.2895L17.564 8.47616Z" stroke="#24252C" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            )}
                            <span className={styles.findMoreText}>
                                {pickerOpen ? "Close" : "Find More Options"}
                            </span>
                        </button>
                    )}

                    {wizardInlinePicker && pickerOpen && !usesVobiz() && (
                        <div
                            id="goLive-inline-picker"
                            className={styles.pickerPanel}
                        >

                            <div className={styles.pickerInputRow}>
                                <div className={styles.pickerLocationInput}>
                                    <GoogleAddressInputWithDropdown
                                        ref={pickerGoogleInputRef}
                                        value={pickerLocationAddress}
                                        onChange={(val) =>
                                            setPickerLocationAddress(val || "")
                                        }
                                        placeholder="Search city (e.g., Irvine, CA)"
                                    />
                                </div>
                                <button
                                    type="button"
                                    className={styles.pickerEditBtn}
                                    onClick={() => pickerGoogleInputRef.current?.focus?.()}
                                    aria-label="Edit location"
                                    title="Edit location"
                                >
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.99853 18.0312C9.34899 18.0312 8.82102 18.4654 8.81641 18.9997C8.81641 19.5377 9.33973 19.9719 9.99392 19.9757L17.9965 19.9985H18.0011C18.6507 19.9985 19.1786 19.5643 19.1833 19.0301C19.1833 18.492 18.6599 18.0578 18.0057 18.054L10.0031 18.0312H9.99853Z" fill="black" />
                                        <path d="M0 15.0337V19.6725H4.70884L20 4.63232L15.2912 0L0 15.0337ZM4.01873 18.0331H1.667V15.7126L12.9297 4.63991L15.2847 6.95181L4.01873 18.0331ZM16.4633 5.79361L14.1083 3.48171L15.2912 2.31829L17.6441 4.63235L16.4633 5.79361Z" fill="black" />
                                    </svg>


                                </button>
                            </div>


                            {pickerLoading ? (
                                <div className={styles.pickerLoading}>
                                    Loading numbers…
                                </div>
                            ) : pickerError ? (
                                <>
                                    <div role="alert" className={styles.pickerErrorBox}>
                                        {pickerError}
                                    </div>

                                    {typeof onWizardSkipPhoneSetup === "function" &&
                                        isCountryGateError && (
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setShowSkipConfirm(true)
                                                }
                                                className={styles.skipLink}
                                            >
                                                Skip phone setup →
                                            </button>
                                        )}
                                </>
                            ) : pickerNumbers.length === 0 ? (
                                <div className={styles.pickerEmpty}>
                                    No numbers available for this location.<br />
                                    <span className={styles.pickerEmptyHint}>
                                        Try a different city or state above.
                                    </span>
                                </div>
                            ) : (
                                <div
                                    role="radiogroup"
                                    aria-label="Available phone numbers"
                                    className={styles.pickerList}
                                >
                                    {pickerNumbers.map((n) => {
                                        const isPicked =
                                            n.phone_number === pickerSelectedNumber;
                                        return (
                                            <button
                                                key={n.phone_number}
                                                type="button"
                                                role="radio"
                                                aria-checked={isPicked}
                                                onClick={() =>
                                                    setPickerSelectedNumber(n.phone_number)
                                                }
                                                className={styles.pickerOption}
                                            >
                                                <span>{n.phone_number}</span>
                                                <span
                                                    className={`${styles.pickerRadio}${isPicked ? ` ${styles.pickerRadioPicked}` : ""}`}
                                                    aria-hidden="true"
                                                />
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    )}


                    {wizardInlinePicker && (
                        <div className={styles.benefitsBox}>
                            <h6 className={styles.benefitsTitle}>
                                Benefits:
                            </h6>
                            <ul className={styles.benefitsList}>
                                {[
                                    "Use this number for call forwarding",
                                    "Keep your existing business number",
                                    `Let ${agentDisplayName} answer forwarded calls`,
                                    "Use this number publicly only if you want",
                                ].map((text) => (
                                    <li key={text} className={styles.benefitsItem}>
                                        <span className={styles.benefitsCheck} aria-hidden="true">
                                            <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                                                <path
                                                    d="M3.5 8L6.5 11L12.5 5"
                                                    stroke="#fff"
                                                    strokeWidth="2.2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </span>
                                        <span className={styles.benefitsText}>
                                            {text}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}


                    {wizardMode && !wizardInlinePicker && wizardCandidateNumber && !selectedNumber && (
                        <p className={styles.wizardHint}>
                            We've held this local number for you. Tap{" "}
                            <b className={styles.highlight}>
                                Confirm Number
                            </b>{" "}
                            to reserve it permanently — or use the{" "}
                            <b className={styles.highlight}>
                                Edit
                            </b>{" "}
                            icon above to pick a different one.
                        </p>
                    )}
                    {wizardMode && !wizardInlinePicker && selectedNumber && !wizardCandidateNumber && (
                        <p className={styles.wizardHint}>
                            You can test your receptionist by calling{" "}
                            <b className={styles.highlight}>
                                {selectedNumber}
                            </b>{" "}
                            &amp; publish this number on your business listings,
                            website or any other public place for your
                            receptionist to answer for your business.
                        </p>
                    )}


                    {wizardMode && wizardConfirmError && (
                        <div role="alert" className={styles.confirmError}>
                            {wizardConfirmError}
                        </div>
                    )}


                    {!wizardMode && (
                        <div className={styles.bottombar}>
                            <p className={styles.desc}>
                                Next, forward your existing business calls to this number.
                            </p>
                            <div className={styles.divider}></div>
                        </div>
                    )}

                    <div
                        className={`${styles.looksGoodBtn}${wizardMode ? ` ${styles.looksGoodBtnWizard}` : ""}`}
                    >
                        {(() => {

                            const isCandidatePreview =
                                wizardMode && wizardCandidateNumber && !selectedNumber;
                            const isInlinePickerCommit =
                                wizardInlinePicker && pickerOpen && !!pickerSelectedNumber;
                            let label;
                            let disabled;
                            if (isInlinePickerCommit) {
                                label = wizardConfirming
                                    ? "Reserving Number..."
                                    : "Use This Number";
                                disabled = wizardConfirming;
                            } else if (wizardInlinePicker && isCandidatePreview) {
                                label = wizardConfirming
                                    ? "Reserving Number..."
                                    : "Continue with this number";
                                disabled = !wizardCandidateNumber || wizardConfirming;
                            } else if (wizardInlinePicker && selectedNumber && !wizardCandidateNumber) {

                                label = "Continue with this number";
                                disabled = isLoading;
                            } else if (isCandidatePreview) {
                                label = wizardConfirming
                                    ? "Reserving Number..."
                                    : "Confirm Number";
                                disabled = !wizardCandidateNumber || wizardConfirming;
                            } else {
                                label = isLoading
                                    ? "Loading..."
                                    : "Set Up Call Forwarding";
                                disabled = isLoading || !selectedNumber;
                            }
                            return (
                                <div className={styles.ctaWrap}>
                                    <AnimatedButton
                                        label={label}
                                        onClick={handleSetupCallForwarding}
                                        disabled={disabled}
                                        positionType={wizardMode ? "relative" : undefined}
                                        bottom="5px"
                                    />
                                    {wizardInlinePicker && (
                                        <p className={styles.pickerNote}>
                                            {isInlinePickerCommit
                                                ? "Confirm to reserve this number for your receptionist."
                                                : `Next, we’ll help you forward calls from your business number to ${agentDisplayName || "your receptionist"}.`}
                                        </p>
                                    )}
                                </div>
                            );
                        })()}
                    </div>
                </div>
            </div>

            {!wizardMode && (
                <div className={styles.crossIcon} onClick={() => setIsModalOpen(true)}>
                    <img src='/svg/cross_icon_gray.svg' alt='cross_icon_gray' />
                </div>
            )}

            <NewModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                title="You can finish this later"
                height="auto"
            >
                <div className={styles.ModalBody}>
                    <div className={styles.worriesDiv}>
                        <span className={styles.dash}>—</span>
                        <strong>No worries</strong>
                        <span className={styles.dash}>—</span>
                        <p>you can set up call forwarding anytime.</p>
                    </div>

                    <p className={styles.description}>
                        For now, you can continue to your{" "}
                        <b className={styles.bolddesc}>dashboard.</b>
                    </p>

                    <div className={styles.CallForwarding}>
                        <AnimatedButton
                            label="Go to Dashboard"
                            positionType='relative'
                            width="auto"
                            bottom="0px"
                            onClick={handleGoToDashboard}
                        />
                    </div>
                </div>
            </NewModal>

            {/* Popup notification */}
            {showPopup && (
                <div className={`${styles.popup} ${styles[popupType]}`}>
                    {popupMessage}
                </div>
            )}
            {showSkipConfirm && (
                <div
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="skip-phone-title"
                    className={styles.skipDialogOverlay}
                    onClick={() => setShowSkipConfirm(false)}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className={styles.skipDialogBox}
                    >
                        <h3 id="skip-phone-title" className={styles.skipDialogTitle}>
                            Skip phone setup?
                        </h3>
                        <p className={styles.skipDialogText}>
                            We don't have phone numbers available in your country
                            yet. You can continue without one — your agent will
                            still work over the web. You'll skip the number,
                            carrier, and call-forwarding steps.
                        </p>
                        <div className={styles.skipDialogActions}>
                            <button
                                type="button"
                                onClick={() => setShowSkipConfirm(false)}
                                className={styles.skipCancelBtn}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                onClick={() => {
                                    setShowSkipConfirm(false);
                                    if (typeof onWizardSkipPhoneSetup === "function") {
                                        onWizardSkipPhoneSetup();
                                    }
                                }}
                                className={styles.skipConfirmBtn}
                            >
                                Skip
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ImmediateOwnerShip;